export default "__VITE_ASSET__BNvvZx_N__"